/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Editor_SubtitleInputs */

const cs_builder_editor_subtitle = /** @type {(inputs: Builder_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skládejte bloky nebo dokument na plátně. Šablonu uložte zde; PDF generujte z inzerátu.`)
};

const en_builder_editor_subtitle = /** @type {(inputs: Builder_Editor_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose with blocks or a document canvas. Save the template here; generate PDFs from a listing.`)
};

/**
* | output |
* | --- |
* | "Compose with blocks or a document canvas. Save the template here; generate PDFs from a listing." |
*
* @param {Builder_Editor_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_editor_subtitle = /** @type {((inputs?: Builder_Editor_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Editor_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_editor_subtitle(inputs)
	return cs_builder_editor_subtitle(inputs)
});